import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createAlbum, deleteAlbum, getUserAlbum, getAlbumContent, removeMediaFromAlbum, getAlbumDetails, getFriendAlbum } from "./albumAction";
import apiInstance from "../../config/api";
import { toast } from "react-toastify";


export const addMediaToAlbum = createAsyncThunk('album/add-media', async ({ files, albumId, medias }, { dispatch }) => {
    const uploadId = `album-content-uploads-${Date.now()}-${Math.random()}`
    try {
        dispatch(addUpload({ medias: medias, id: uploadId }))
        const formData = new FormData()
        if (files && files.length > 0) {
            files.forEach((file) => {
                formData.append(`files`, file);
            });
        }
        const request = await apiInstance.post(`/album/api/album/files/${albumId}`, formData, {
            onUploadProgress: files?.length > 0 ? (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                dispatch(setUploadProgress({ id: uploadId, progress: percent }));
            } : undefined,
        });
        const response = request.data
        console.log("media uploaded; ", response)
        if (response.message === 'Files uploaded successfully') {
            toast.success("Files uploaded successfully")
            dispatch(finishUpload({ id: uploadId }))

            return response.album
        } else {
            toast.error("Files uploaded failed")

            throw new Error(response.message)
        }
    }
    catch (error) {
        toast.error("File failed to Upload")
        dispatch(finishUpload({ id: uploadId }))
        throw new Error(error.message)
    }
})

const initialState = {
    uploads: [],

    loading: false,
    creating: false,
    myAlbums: [],

    addingMedia: false,
    removingMedia: false,


    loadingFriendAlbums: false,
    friendAlbums: [],
    friendAlbumError: null,

    loadingAlbumContent: false,
    albums: {},
    albumContents: {},
    error: null
}

const albumSlice = createSlice({
    name: 'album',
    initialState,
    reducers: {
        addUpload(state, action) {
            const { medias, id } = action.payload
            state.uploads.push({
                id: id,
                medias: medias,
                progress: 0,
                uploading: true,
            });
        },
        setUploadProgress(state, action) {
            const upload = state.uploads.find((u) => u.id === action.payload.id);
            if (upload) {
                upload.progress = action.payload.progress;
            }
        },
        finishUpload(state, action) {
            state.uploads = state.uploads.filter((u) => u.id !== action.payload.id);
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(createAlbum.pending, (state) => {
                state.creating = true
            })
            .addCase(createAlbum.fulfilled, (state, action) => {
                state.creating = false
                state.myAlbums.push(action.payload)
            })
            .addCase(createAlbum.rejected, (state, action) => {
                state.creating = false
                state.error = action.error.message
            })

        builder
            .addCase(getUserAlbum.pending, (state) => {
                state.loading = true
            })
            .addCase(getUserAlbum.fulfilled, (state, action) => {
                state.loading = false
                state.myAlbums = action.payload
            })
            .addCase(getUserAlbum.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

        builder
            .addCase(deleteAlbum.fulfilled, (state, action) => {
                const { albumId, status } = action.payload
                if (status === 'success') {
                    const filteredAlbum = state.myAlbums.filter(album => album.albumId !== albumId)
                    state.myAlbums = filteredAlbum
                    if (state.albumContents[albumId]) delete state.albumContents[albumId]
                }
            })

        builder
            .addCase(getAlbumDetails.fulfilled, (state, action) => {
                const { albumId, data } = action.payload
                state.albums[albumId] = data
            })

        builder
            .addCase(getAlbumContent.pending, (state) => {
                state.loadingAlbumContent = true
            })
            .addCase(getAlbumContent.fulfilled, (state, action) => {
                state.loadingAlbumContent = false
                const { albumId, data } = action.payload
                state.albumContents[albumId] = data
            })
            .addCase(getAlbumContent.rejected, (state, action) => {
                state.loadingAlbumContent = false
                state.error = action.error.message
            })

        builder
            .addCase(addMediaToAlbum.pending, (state) => {
                state.addingMedia = true
            })
            .addCase(addMediaToAlbum.fulfilled, (state, action) => {
                const { albumId, postUrl } = action.payload
                state.albumContents[albumId]?.unshift(...postUrl)
                state.addingMedia = false
            })
            .addCase(addMediaToAlbum.rejected, (state, action) => {
                state.addingMedia = false
                state.error = action.error.message
            })

        builder
            .addCase(removeMediaFromAlbum.pending, (state) => {
                state.removingMedia = true
            })
            .addCase(removeMediaFromAlbum.fulfilled, (state, action) => {
                state.removingMedia = false
                const { results, albumId } = action.payload
                const imageNamesToRemove = new Set(results.map(result => result.imageName));
                const filteredContent = state.albumContents[albumId]?.filter(
                    content => !imageNamesToRemove.has(content.imageName)
                );
                state.albumContents[albumId] = filteredContent;
            })
            .addCase(removeMediaFromAlbum.rejected, (state, action) => {
                state.removingMedia = false
                state.error = action.error.message
            })

        builder
            .addCase(getFriendAlbum.pending, (state) => {
                state.loadingFriendAlbums = true
                state.friendAlbums = []
            })
            .addCase(getFriendAlbum.fulfilled, (state, action) => {
                state.loadingFriendAlbums = false
                state.friendAlbums = action.payload
            })
            .addCase(getFriendAlbum.rejected, (state, action) => {
                state.loadingFriendAlbums = false
                state.friendAlbumError = action.error.message
            })
    }
})

export const { addUpload, setUploadProgress, finishUpload } = albumSlice.actions
export default albumSlice.reducer